import { usePageTitle } from "../../libs/hooksLib";

export default function BasicRoute({title, children}){
    usePageTitle(title);
    return children;
}